export const AccountCampaignSlug = {
    ElmyClient: "client_elmy",
    EnergyLandscape: "paysage_energetique_ok",
    FanClub: "fan_club",
    Fleximax: "fleximax",
    OctoshieldActivate: "octoshield_activate",
    BypassRisklistBank: "bypass_risklist_bank",
    RisklistBank: "risklist_bank",
    RisklistDebt: "risklist_debt",
    Ford1Year: "ford_1_year",
    Ford3Years: "ford_3_years",
    PendingPrepayment: "pending_prepayment",
    GasEligible: "eligibilite_gaz",
    BalanceVisible: "balance_visible",
    GbxDisplay: "gbx_display",
    VulnerableCustomer: "client_vulnerable",
    CrossSellGazJuly26: "cross_sell_gaz_july_26",
} as const

export type AccountCampaignSlug = (typeof AccountCampaignSlug)[keyof typeof AccountCampaignSlug]
